<template>
    <div
        class="sizes-guide-zoom pos-fixed pos-all bg-white z-max scroll"
        style="overflow-y: scroll"
    >
        <div class="sizes-guide-zoom-content content d-flex flex-column text-center text-yanone">
            <div class="flex-child-fixed pos-relative mt-5">
                <div class="pos-absolute pos-left pos-center-y d-flex flex-align-center">
                    <div class="sizes-guide-logo-cr logo-cr-size-guide mr-2" />
                </div>
                <span class="pos-absolute pos-right pos-center-y cursor-pointer">
                    <i class="icon-cr icon-cr-hover icon-close d-block" @click="$emit('hide')" />
                </span>
            </div>
            <div
                class="pos-relative mt-5 flex-grid flex-justify-center flex-item-grow overflow-hidden h-full"
            >
                <div class="flex-xs-12 flex-sm-6 flex-md-4 flex-lg-4 video-box">
                    <span
                        class="h1 pos-absolute pos-left z-max pos-center-y pos-top cursor-pointer my-0"
                        @click="$emit('go-previous')"
                    >
                        <i class="icon-cr icon-chevron-left accent" />
                    </span>
                    <span
                        class="h1 pos-absolute pos-right z-max pos-center-y pos-top cursor-pointer my-0"
                        @click="$emit('go-next')"
                    >
                        <i class="icon-cr icon-chevron-right accent" />
                    </span>
                    <div class="hidden-sm-up mb-3">
                        <span v-if="currentModel.nome">Modelo: {{ currentModel.nome }} |</span>
                        <span v-if="currentModel.altura !== 0"
                            >Altura: {{ currentModel.altura / 100 }} m |</span
                        >
                        <span v-if="currentModel.busto !== 0"
                            >Busto: {{ currentModel.busto }} cm|</span
                        >
                        <span v-if="currentModel.cintura !== 0"
                            >Cintura: {{ currentModel.cintura }} cm |</span
                        >
                        <span v-if="currentModel.quadril !== 0"
                            >Quadril: {{ currentModel.quadril }} cm</span
                        >
                    </div>
                    <div
                        v-if="!loading"
                        style="gap: 0.625rem"
                        class="photo-type d-flex overflow-hidden hidden-sm-up flex-justify-center"
                    >
                        <button
                            v-for="(type, index) in productModel.size_guide_media_type"
                            class="btn"
                            :class="{ selected: index === selectedType }"
                            @click="selectType(index)"
                        >
                            {{ type }}
                        </button>
                    </div>
                    <div :class="{ 'iframe-dimension': !isMobile }">
                        <img
                            v-if="!isVideo"
                            :key="currentImage.id"
                            :src="sourceImgOrVideo"
                            alt="Imagem do modelo"
                            class="border-radius img-responsive flex-child-fixed"
                            :class="{ 'img-responsive': isMobile }"
                            @load="isLoaded()"
                        />
                        <div class="iframe-dimension overflow-hidden" v-else>
                            <iframe
                                :src="sourceImgOrVideo"
                                ref="zoomImage"
                                frameborder="0"
                                class="border-radius flex-child-fixed"
                                @load="isLoaded()"
                                allow="autoplay; fullscreen; picture-in-picture"
                            ></iframe>
                        </div>
                    </div>

                    <span v-if="loading" class="cr-spinner flex-child-fixed" />

                    <div
                        v-if="!loading"
                        style="gap: 0.625rem"
                        class="photo-type d-inline-flex overflow-hidden hidden-sm-down flex-justify-center pb-0 mt-3"
                    >
                        <button
                            v-if="availableTypes.includes(index)"
                            v-for="(type, index) in productModel.size_guide_media_type"
                            class="btn"
                            :class="{ selected: index === selectedType }"
                            @click="selectType(index)"
                        >
                            {{ type }}
                        </button>
                    </div>
                </div>
                <div class="flex-xs-12 flex-sm-6 flex-md-4 flex-lg-4">
                    <SizeGuideZoomInfo
                        :current-model="currentModel"
                        :product-model="productModel"
                        :current-dimension="currentDimension"
                        :sizes="sizes"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import SizeGuideZoomInfo from './SizeGuideZoomInfo.vue';
    import { resizeOrientationAware } from '../../../common/common';

    export default {
        name: 'SizeGuideZoomV2',

        components: {
            SizeGuideZoomInfo,
        },

        props: {
            currentModel: {
                type: Object,
                required: true,
            },
            productModel: {
                type: Object,
                required: true,
            },
            currentSizeId: {
                type: Number,
            },
            sizes: {
                type: Object,
                required: true,
            },
        },

        data() {
            return {
                loading: true,
                selectedType: 1,
                url_id: parseInt(this.$route.params.modelName.match(/\d+/g).join('')),
                isMobile: null,
                resizeAwareRemoveCb: null,
            };
        },

        mounted() {
            this.resizeAwareRemoveCb = resizeOrientationAware(() => this.onResize(), true);
        },

        beforeDestroy() {
            this.resizeAwareRemoveCb();
        },

        watch: {
            currentSizeId(to) {
                if (!this.availableTypes.includes(this.selectedType)) {
                    this.selectedType = this.availableTypes[0];
                }
            },
        },

        computed: {
            ready() {
                return this.currentModel && this.currentModel.images && this.currentImage;
            },

            sourceImgOrVideo() {
                if (!this.isVideo) {
                    return this.ready
                        ? `${this.$scope.CDN_IMAGES}/images/site/guia-de-tamanhos/${
                              this.productModel.product_type_id
                          }/${this.sizes[this.currentSizeId].name}/${
                              this.currentImage.url
                          }?auto=compress,format&q=65&w=800`
                        : null;
                } else {
                    let url = new URL(this.currentImage.url);
                    url.searchParams.set('background', 1);
                    return this.ready ? url.toString() : null;
                }
            },

            filteredImages() {
                return this.currentModel.images.filter((image) => {
                    return image.size_id === this.currentSizeId && image.main_video === 0;
                });
            },

            currentImage() {
                return this.filteredImages.find(
                    (image) => image.type_id === parseInt(this.selectedType)
                );
            },

            currentDimension() {
                return this.productModel.dimensions.find(
                    (dimension) => dimension.size_id === this.currentImage.size_id
                );
            },

            isVideo() {
                return parseInt(this.selectedType) === 4;
            },

            availableTypes() {
                let availableTypes = {};
                this.filteredImages.forEach((i) => {
                    availableTypes[i.type_id] = true;
                });
                return Object.keys(availableTypes);
            },
        },

        methods: {
            selectType(type) {
                this.selectedType = type;
                this.$emit('type-changed', this.selectedType);
            },

            isLoaded() {
                this.$nextTick(() => {
                    this.loading = false;
                });
            },

            onResize() {
                this.isMobile = window.innerWidth < 768;
            },
        },
    };
</script>
